import React from 'react'

export default function LifetimeSubscriptions() {
  return (
    <div>LifetimeSubscriptions</div>
  )
}

